/**
 * Generated by orval v6.24.0 🍺
 * Do not edit manually.
 * BackendEntryPoint
 * API for managing users, tracks, and projects for a code evaluation platform.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AccountUsers,
  AlgoEvaluation,
  Company,
  DevUser,
  GetEvaluationprogress200,
  GetEvaluationprogressParams,
  GetHiringcampaignsSearch200,
  GetHiringcampaignsSearchParams,
  GetHiringresultsSearch200,
  GetHiringresultsSearchParams,
  GetProjectContextParams,
  GetProjectsSearchParams,
  GetSebFileParams,
  GetTracksSearchParams,
  GetUserDeveloperSearchApiParams,
  GetUserDeveloperSearchParams,
  GetUserHiringresourceSearchApiParams,
  GetUserHiringresourceSearchParams,
  HiringCampaign,
  HiringResult,
  HrUser,
  License,
  Performance,
  Permission,
  PostApply200,
  PostApply400,
  PostApply500,
  PostApplyBody,
  PostRuntest200,
  PostRuntest400,
  PostRuntest500,
  PostRuntestBody,
  PostTracksBody,
  Project,
  ProjectContext,
  PutHiringresultsParams,
  SubmitAlgoEvaluation201,
  Track,
  TrackHomePage
} from '../../model'
import { customClient } from '../../../mutator/custom-client';
import type { ErrorType, BodyType } from '../../../mutator/custom-client';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Get a dev users by sub
 */
export const getUserDeveloper = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<DevUser>(
      {url: `/user-developer`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserDeveloperQueryKey = () => {
    return [`/user-developer`] as const;
    }

    
export const getGetUserDeveloperQueryOptions = <TData = Awaited<ReturnType<typeof getUserDeveloper>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloper>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDeveloperQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDeveloper>>> = ({ signal }) => getUserDeveloper(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloper>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserDeveloperQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDeveloper>>>
export type GetUserDeveloperQueryError = ErrorType<void>

/**
 * @summary Get a dev users by sub
 */
export const useGetUserDeveloper = <TData = Awaited<ReturnType<typeof getUserDeveloper>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloper>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserDeveloperQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new dev user
 */
export const postUserDeveloper = (
    devUser: BodyType<DevUser>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<DevUser>(
      {url: `/user-developer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: devUser
    },
      options);
    }
  


export const getPostUserDeveloperMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserDeveloper>>, TError,{data: BodyType<DevUser>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserDeveloper>>, TError,{data: BodyType<DevUser>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserDeveloper>>, {data: BodyType<DevUser>}> = (props) => {
          const {data} = props ?? {};

          return  postUserDeveloper(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserDeveloperMutationResult = NonNullable<Awaited<ReturnType<typeof postUserDeveloper>>>
    export type PostUserDeveloperMutationBody = BodyType<DevUser>
    export type PostUserDeveloperMutationError = ErrorType<void>

    /**
 * @summary Create a new dev user
 */
export const usePostUserDeveloper = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserDeveloper>>, TError,{data: BodyType<DevUser>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostUserDeveloperMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update a dev user
 */
export const putUserDeveloper = (
    devUser: BodyType<DevUser>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<DevUser>(
      {url: `/user-developer`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: devUser
    },
      options);
    }
  


export const getPutUserDeveloperMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserDeveloper>>, TError,{data: BodyType<DevUser>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserDeveloper>>, TError,{data: BodyType<DevUser>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserDeveloper>>, {data: BodyType<DevUser>}> = (props) => {
          const {data} = props ?? {};

          return  putUserDeveloper(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserDeveloperMutationResult = NonNullable<Awaited<ReturnType<typeof putUserDeveloper>>>
    export type PutUserDeveloperMutationBody = BodyType<DevUser>
    export type PutUserDeveloperMutationError = ErrorType<void>

    /**
 * @summary Update a dev user
 */
export const usePutUserDeveloper = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserDeveloper>>, TError,{data: BodyType<DevUser>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutUserDeveloperMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a dev users by using a querry
 */
export const getUserDeveloperSearchApi = (
    params?: GetUserDeveloperSearchApiParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<DevUser[]>(
      {url: `/user-developer/search/api`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserDeveloperSearchApiQueryKey = (params?: GetUserDeveloperSearchApiParams,) => {
    return [`/user-developer/search/api`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserDeveloperSearchApiQueryOptions = <TData = Awaited<ReturnType<typeof getUserDeveloperSearchApi>>, TError = ErrorType<void>>(params?: GetUserDeveloperSearchApiParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperSearchApi>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDeveloperSearchApiQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDeveloperSearchApi>>> = ({ signal }) => getUserDeveloperSearchApi(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperSearchApi>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserDeveloperSearchApiQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDeveloperSearchApi>>>
export type GetUserDeveloperSearchApiQueryError = ErrorType<void>

/**
 * @summary Get a dev users by using a querry
 */
export const useGetUserDeveloperSearchApi = <TData = Awaited<ReturnType<typeof getUserDeveloperSearchApi>>, TError = ErrorType<void>>(
 params?: GetUserDeveloperSearchApiParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperSearchApi>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserDeveloperSearchApiQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a dev users by using a querry
 */
export const getUserDeveloperSearch = (
    params?: GetUserDeveloperSearchParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<DevUser[]>(
      {url: `/user-developer/search/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserDeveloperSearchQueryKey = (params?: GetUserDeveloperSearchParams,) => {
    return [`/user-developer/search/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserDeveloperSearchQueryOptions = <TData = Awaited<ReturnType<typeof getUserDeveloperSearch>>, TError = ErrorType<void>>(params?: GetUserDeveloperSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDeveloperSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDeveloperSearch>>> = ({ signal }) => getUserDeveloperSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserDeveloperSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDeveloperSearch>>>
export type GetUserDeveloperSearchQueryError = ErrorType<void>

/**
 * @summary Get a dev users by using a querry
 */
export const useGetUserDeveloperSearch = <TData = Awaited<ReturnType<typeof getUserDeveloperSearch>>, TError = ErrorType<void>>(
 params?: GetUserDeveloperSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserDeveloperSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a dev user by ID
 */
export const getUserDeveloperUserId = (
    userId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<DevUser>(
      {url: `/user-developer/${userId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserDeveloperUserIdQueryKey = (userId: string,) => {
    return [`/user-developer/${userId}`] as const;
    }

    
export const getGetUserDeveloperUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserDeveloperUserId>>, TError = ErrorType<void>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperUserId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDeveloperUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDeveloperUserId>>> = ({ signal }) => getUserDeveloperUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperUserId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserDeveloperUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDeveloperUserId>>>
export type GetUserDeveloperUserIdQueryError = ErrorType<void>

/**
 * @summary Get a dev user by ID
 */
export const useGetUserDeveloperUserId = <TData = Awaited<ReturnType<typeof getUserDeveloperUserId>>, TError = ErrorType<void>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDeveloperUserId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserDeveloperUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a dev user by ID
 */
export const putUserDeveloperUserId = (
    userId: string,
    devUser: BodyType<DevUser>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/user-developer/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: devUser
    },
      options);
    }
  


export const getPutUserDeveloperUserIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserDeveloperUserId>>, TError,{userId: string;data: BodyType<DevUser>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserDeveloperUserId>>, TError,{userId: string;data: BodyType<DevUser>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserDeveloperUserId>>, {userId: string;data: BodyType<DevUser>}> = (props) => {
          const {userId,data} = props ?? {};

          return  putUserDeveloperUserId(userId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserDeveloperUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserDeveloperUserId>>>
    export type PutUserDeveloperUserIdMutationBody = BodyType<DevUser>
    export type PutUserDeveloperUserIdMutationError = ErrorType<unknown>

    /**
 * @summary Update a dev user by ID
 */
export const usePutUserDeveloperUserId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserDeveloperUserId>>, TError,{userId: string;data: BodyType<DevUser>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutUserDeveloperUserIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a dev user by ID
 */
export const deleteUserDeveloperUserId = (
    userId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/user-developer/${userId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUserDeveloperUserIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserDeveloperUserId>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserDeveloperUserId>>, TError,{userId: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserDeveloperUserId>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deleteUserDeveloperUserId(userId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteUserDeveloperUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserDeveloperUserId>>>
    
    export type DeleteUserDeveloperUserIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a dev user by ID
 */
export const useDeleteUserDeveloperUserId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserDeveloperUserId>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeleteUserDeveloperUserIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a hr users by sub
 */
export const getUserHiringresource = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<HrUser>(
      {url: `/user-hiringresource`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserHiringresourceQueryKey = () => {
    return [`/user-hiringresource`] as const;
    }

    
export const getGetUserHiringresourceQueryOptions = <TData = Awaited<ReturnType<typeof getUserHiringresource>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresource>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserHiringresourceQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserHiringresource>>> = ({ signal }) => getUserHiringresource(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresource>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserHiringresourceQueryResult = NonNullable<Awaited<ReturnType<typeof getUserHiringresource>>>
export type GetUserHiringresourceQueryError = ErrorType<void>

/**
 * @summary Get a hr users by sub
 */
export const useGetUserHiringresource = <TData = Awaited<ReturnType<typeof getUserHiringresource>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresource>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserHiringresourceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new hr user
 */
export const postUserHiringresource = (
    hrUser: BodyType<HrUser>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<HrUser>(
      {url: `/user-hiringresource`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hrUser
    },
      options);
    }
  


export const getPostUserHiringresourceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserHiringresource>>, TError,{data: BodyType<HrUser>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserHiringresource>>, TError,{data: BodyType<HrUser>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserHiringresource>>, {data: BodyType<HrUser>}> = (props) => {
          const {data} = props ?? {};

          return  postUserHiringresource(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserHiringresourceMutationResult = NonNullable<Awaited<ReturnType<typeof postUserHiringresource>>>
    export type PostUserHiringresourceMutationBody = BodyType<HrUser>
    export type PostUserHiringresourceMutationError = ErrorType<void>

    /**
 * @summary Create a new hr user
 */
export const usePostUserHiringresource = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserHiringresource>>, TError,{data: BodyType<HrUser>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostUserHiringresourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update a hr user
 */
export const putUserHiringresource = (
    hrUser: BodyType<HrUser>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<HrUser>(
      {url: `/user-hiringresource`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hrUser
    },
      options);
    }
  


export const getPutUserHiringresourceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserHiringresource>>, TError,{data: BodyType<HrUser>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserHiringresource>>, TError,{data: BodyType<HrUser>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserHiringresource>>, {data: BodyType<HrUser>}> = (props) => {
          const {data} = props ?? {};

          return  putUserHiringresource(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserHiringresourceMutationResult = NonNullable<Awaited<ReturnType<typeof putUserHiringresource>>>
    export type PutUserHiringresourceMutationBody = BodyType<HrUser>
    export type PutUserHiringresourceMutationError = ErrorType<void>

    /**
 * @summary Update a hr user
 */
export const usePutUserHiringresource = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserHiringresource>>, TError,{data: BodyType<HrUser>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutUserHiringresourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a hr users by using a querry
 */
export const getUserHiringresourceSearchApi = (
    params?: GetUserHiringresourceSearchApiParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<HrUser[]>(
      {url: `/user-hiringresource/search/api`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserHiringresourceSearchApiQueryKey = (params?: GetUserHiringresourceSearchApiParams,) => {
    return [`/user-hiringresource/search/api`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserHiringresourceSearchApiQueryOptions = <TData = Awaited<ReturnType<typeof getUserHiringresourceSearchApi>>, TError = ErrorType<void>>(params?: GetUserHiringresourceSearchApiParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceSearchApi>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserHiringresourceSearchApiQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserHiringresourceSearchApi>>> = ({ signal }) => getUserHiringresourceSearchApi(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceSearchApi>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserHiringresourceSearchApiQueryResult = NonNullable<Awaited<ReturnType<typeof getUserHiringresourceSearchApi>>>
export type GetUserHiringresourceSearchApiQueryError = ErrorType<void>

/**
 * @summary Get a hr users by using a querry
 */
export const useGetUserHiringresourceSearchApi = <TData = Awaited<ReturnType<typeof getUserHiringresourceSearchApi>>, TError = ErrorType<void>>(
 params?: GetUserHiringresourceSearchApiParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceSearchApi>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserHiringresourceSearchApiQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a hr users by using a id querry
 */
export const getUserHiringresourceSearch = (
    params?: GetUserHiringresourceSearchParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<HrUser[]>(
      {url: `/user-hiringresource/search/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserHiringresourceSearchQueryKey = (params?: GetUserHiringresourceSearchParams,) => {
    return [`/user-hiringresource/search/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserHiringresourceSearchQueryOptions = <TData = Awaited<ReturnType<typeof getUserHiringresourceSearch>>, TError = ErrorType<void>>(params?: GetUserHiringresourceSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserHiringresourceSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserHiringresourceSearch>>> = ({ signal }) => getUserHiringresourceSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserHiringresourceSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getUserHiringresourceSearch>>>
export type GetUserHiringresourceSearchQueryError = ErrorType<void>

/**
 * @summary Get a hr users by using a id querry
 */
export const useGetUserHiringresourceSearch = <TData = Awaited<ReturnType<typeof getUserHiringresourceSearch>>, TError = ErrorType<void>>(
 params?: GetUserHiringresourceSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserHiringresourceSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a user by ID
 */
export const getUserHiringresourceUserId = (
    userId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<HrUser>(
      {url: `/user-hiringresource/${userId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserHiringresourceUserIdQueryKey = (userId: string,) => {
    return [`/user-hiringresource/${userId}`] as const;
    }

    
export const getGetUserHiringresourceUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserHiringresourceUserId>>, TError = ErrorType<void>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceUserId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserHiringresourceUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserHiringresourceUserId>>> = ({ signal }) => getUserHiringresourceUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceUserId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserHiringresourceUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserHiringresourceUserId>>>
export type GetUserHiringresourceUserIdQueryError = ErrorType<void>

/**
 * @summary Get a user by ID
 */
export const useGetUserHiringresourceUserId = <TData = Awaited<ReturnType<typeof getUserHiringresourceUserId>>, TError = ErrorType<void>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceUserId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserHiringresourceUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a user by ID
 */
export const putUserHiringresourceUserId = (
    userId: string,
    hrUser: BodyType<HrUser>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/user-hiringresource/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hrUser
    },
      options);
    }
  


export const getPutUserHiringresourceUserIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserHiringresourceUserId>>, TError,{userId: string;data: BodyType<HrUser>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserHiringresourceUserId>>, TError,{userId: string;data: BodyType<HrUser>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserHiringresourceUserId>>, {userId: string;data: BodyType<HrUser>}> = (props) => {
          const {userId,data} = props ?? {};

          return  putUserHiringresourceUserId(userId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserHiringresourceUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserHiringresourceUserId>>>
    export type PutUserHiringresourceUserIdMutationBody = BodyType<HrUser>
    export type PutUserHiringresourceUserIdMutationError = ErrorType<unknown>

    /**
 * @summary Update a user by ID
 */
export const usePutUserHiringresourceUserId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserHiringresourceUserId>>, TError,{userId: string;data: BodyType<HrUser>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutUserHiringresourceUserIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a user by ID
 */
export const deleteUserHiringresourceUserId = (
    userId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/user-hiringresource/${userId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUserHiringresourceUserIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserHiringresourceUserId>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserHiringresourceUserId>>, TError,{userId: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserHiringresourceUserId>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deleteUserHiringresourceUserId(userId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteUserHiringresourceUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserHiringresourceUserId>>>
    
    export type DeleteUserHiringresourceUserIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a user by ID
 */
export const useDeleteUserHiringresourceUserId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserHiringresourceUserId>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeleteUserHiringresourceUserIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserHiringresourceAccount = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AccountUsers[]>(
      {url: `/user-hiringresource/account`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserHiringresourceAccountQueryKey = () => {
    return [`/user-hiringresource/account`] as const;
    }

    
export const getGetUserHiringresourceAccountQueryOptions = <TData = Awaited<ReturnType<typeof getUserHiringresourceAccount>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceAccount>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserHiringresourceAccountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserHiringresourceAccount>>> = ({ signal }) => getUserHiringresourceAccount(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserHiringresourceAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getUserHiringresourceAccount>>>
export type GetUserHiringresourceAccountQueryError = ErrorType<void>

export const useGetUserHiringresourceAccount = <TData = Awaited<ReturnType<typeof getUserHiringresourceAccount>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserHiringresourceAccount>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserHiringresourceAccountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a list of all tracks using querries
 */
export const getTracks = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Track[]>(
      {url: `/tracks`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTracksQueryKey = () => {
    return [`/tracks`] as const;
    }

    
export const getGetTracksQueryOptions = <TData = Awaited<ReturnType<typeof getTracks>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTracksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracks>>> = ({ signal }) => getTracks(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTracks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTracksQueryResult = NonNullable<Awaited<ReturnType<typeof getTracks>>>
export type GetTracksQueryError = ErrorType<void>

/**
 * @summary Get a list of all tracks using querries
 */
export const useGetTracks = <TData = Awaited<ReturnType<typeof getTracks>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracks>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTracksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new track
 */
export const postTracks = (
    postTracksBody: BodyType<PostTracksBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Track>(
      {url: `/tracks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTracksBody
    },
      options);
    }
  


export const getPostTracksMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTracks>>, TError,{data: BodyType<PostTracksBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postTracks>>, TError,{data: BodyType<PostTracksBody>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTracks>>, {data: BodyType<PostTracksBody>}> = (props) => {
          const {data} = props ?? {};

          return  postTracks(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostTracksMutationResult = NonNullable<Awaited<ReturnType<typeof postTracks>>>
    export type PostTracksMutationBody = BodyType<PostTracksBody>
    export type PostTracksMutationError = ErrorType<void>

    /**
 * @summary Create a new track
 */
export const usePostTracks = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTracks>>, TError,{data: BodyType<PostTracksBody>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostTracksMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get tracks-like data using query params
 */
export const getTracksSearch = (
    params?: GetTracksSearchParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<TrackHomePage[]>(
      {url: `/tracks/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetTracksSearchQueryKey = (params?: GetTracksSearchParams,) => {
    return [`/tracks/search`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTracksSearchQueryOptions = <TData = Awaited<ReturnType<typeof getTracksSearch>>, TError = ErrorType<void>>(params?: GetTracksSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracksSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTracksSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracksSearch>>> = ({ signal }) => getTracksSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTracksSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTracksSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getTracksSearch>>>
export type GetTracksSearchQueryError = ErrorType<void>

/**
 * @summary Get tracks-like data using query params
 */
export const useGetTracksSearch = <TData = Awaited<ReturnType<typeof getTracksSearch>>, TError = ErrorType<void>>(
 params?: GetTracksSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracksSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTracksSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a track by ID
 */
export const getTracksTrackId = (
    trackId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Track>(
      {url: `/tracks/${trackId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTracksTrackIdQueryKey = (trackId: string,) => {
    return [`/tracks/${trackId}`] as const;
    }

    
export const getGetTracksTrackIdQueryOptions = <TData = Awaited<ReturnType<typeof getTracksTrackId>>, TError = ErrorType<void>>(trackId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracksTrackId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTracksTrackIdQueryKey(trackId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracksTrackId>>> = ({ signal }) => getTracksTrackId(trackId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(trackId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTracksTrackId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTracksTrackIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTracksTrackId>>>
export type GetTracksTrackIdQueryError = ErrorType<void>

/**
 * @summary Get a track by ID
 */
export const useGetTracksTrackId = <TData = Awaited<ReturnType<typeof getTracksTrackId>>, TError = ErrorType<void>>(
 trackId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracksTrackId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTracksTrackIdQueryOptions(trackId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a track by ID
 */
export const putTracksTrackId = (
    trackId: string,
    track: BodyType<Track>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Track>(
      {url: `/tracks/${trackId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: track
    },
      options);
    }
  


export const getPutTracksTrackIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTracksTrackId>>, TError,{trackId: string;data: BodyType<Track>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putTracksTrackId>>, TError,{trackId: string;data: BodyType<Track>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTracksTrackId>>, {trackId: string;data: BodyType<Track>}> = (props) => {
          const {trackId,data} = props ?? {};

          return  putTracksTrackId(trackId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutTracksTrackIdMutationResult = NonNullable<Awaited<ReturnType<typeof putTracksTrackId>>>
    export type PutTracksTrackIdMutationBody = BodyType<Track>
    export type PutTracksTrackIdMutationError = ErrorType<void>

    /**
 * @summary Update a track by ID
 */
export const usePutTracksTrackId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTracksTrackId>>, TError,{trackId: string;data: BodyType<Track>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutTracksTrackIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a track by ID
 */
export const deleteTracksTrackId = (
    trackId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/tracks/${trackId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTracksTrackIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTracksTrackId>>, TError,{trackId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTracksTrackId>>, TError,{trackId: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTracksTrackId>>, {trackId: string}> = (props) => {
          const {trackId} = props ?? {};

          return  deleteTracksTrackId(trackId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteTracksTrackIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTracksTrackId>>>
    
    export type DeleteTracksTrackIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a track by ID
 */
export const useDeleteTracksTrackId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTracksTrackId>>, TError,{trackId: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeleteTracksTrackIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a list of all projects by using the sub
 */
export const getProjects = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Project[]>(
      {url: `/projects`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProjectsQueryKey = () => {
    return [`/projects`] as const;
    }

    
export const getGetProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getProjects>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjects>>> = ({ signal }) => getProjects(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getProjects>>>
export type GetProjectsQueryError = ErrorType<void>

/**
 * @summary Get a list of all projects by using the sub
 */
export const useGetProjects = <TData = Awaited<ReturnType<typeof getProjects>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjects>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a new project
 */
export const postProjects = (
    project: BodyType<Project>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Project>(
      {url: `/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: project
    },
      options);
    }
  


export const getPostProjectsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProjects>>, TError,{data: BodyType<Project>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postProjects>>, TError,{data: BodyType<Project>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProjects>>, {data: BodyType<Project>}> = (props) => {
          const {data} = props ?? {};

          return  postProjects(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostProjectsMutationResult = NonNullable<Awaited<ReturnType<typeof postProjects>>>
    export type PostProjectsMutationBody = BodyType<Project>
    export type PostProjectsMutationError = ErrorType<void>

    /**
 * @summary Create a new project
 */
export const usePostProjects = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProjects>>, TError,{data: BodyType<Project>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostProjectsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Submits a new algorithm evaluation to the database
 * @summary Submit an algorithm evaluation
 */
export const submitAlgoEvaluation = (
    algoEvaluation: BodyType<AlgoEvaluation>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<SubmitAlgoEvaluation201>(
      {url: `/projects/algorithms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: algoEvaluation
    },
      options);
    }
  


export const getSubmitAlgoEvaluationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAlgoEvaluation>>, TError,{data: BodyType<AlgoEvaluation>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof submitAlgoEvaluation>>, TError,{data: BodyType<AlgoEvaluation>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitAlgoEvaluation>>, {data: BodyType<AlgoEvaluation>}> = (props) => {
          const {data} = props ?? {};

          return  submitAlgoEvaluation(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type SubmitAlgoEvaluationMutationResult = NonNullable<Awaited<ReturnType<typeof submitAlgoEvaluation>>>
    export type SubmitAlgoEvaluationMutationBody = BodyType<AlgoEvaluation>
    export type SubmitAlgoEvaluationMutationError = ErrorType<void>

    /**
 * @summary Submit an algorithm evaluation
 */
export const useSubmitAlgoEvaluation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitAlgoEvaluation>>, TError,{data: BodyType<AlgoEvaluation>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getSubmitAlgoEvaluationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieves an algorithm evaluation using its unique ID
 * @summary Get an algorithm evaluation by ID
 */
export const getAlgoEvaluation = (
    evalId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<AlgoEvaluation>(
      {url: `/projects/algorithms/${evalId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAlgoEvaluationQueryKey = (evalId: string,) => {
    return [`/projects/algorithms/${evalId}`] as const;
    }

    
export const getGetAlgoEvaluationQueryOptions = <TData = Awaited<ReturnType<typeof getAlgoEvaluation>>, TError = ErrorType<void>>(evalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlgoEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlgoEvaluationQueryKey(evalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlgoEvaluation>>> = ({ signal }) => getAlgoEvaluation(evalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(evalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlgoEvaluation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAlgoEvaluationQueryResult = NonNullable<Awaited<ReturnType<typeof getAlgoEvaluation>>>
export type GetAlgoEvaluationQueryError = ErrorType<void>

/**
 * @summary Get an algorithm evaluation by ID
 */
export const useGetAlgoEvaluation = <TData = Awaited<ReturnType<typeof getAlgoEvaluation>>, TError = ErrorType<void>>(
 evalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAlgoEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAlgoEvaluationQueryOptions(evalId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a Project by using a querry ID
 */
export const getProjectsSearch = (
    params?: GetProjectsSearchParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Project[]>(
      {url: `/projects/search/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetProjectsSearchQueryKey = (params?: GetProjectsSearchParams,) => {
    return [`/projects/search/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProjectsSearchQueryOptions = <TData = Awaited<ReturnType<typeof getProjectsSearch>>, TError = ErrorType<void>>(params?: GetProjectsSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectsSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectsSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectsSearch>>> = ({ signal }) => getProjectsSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectsSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectsSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectsSearch>>>
export type GetProjectsSearchQueryError = ErrorType<void>

/**
 * @summary Get a Project by using a querry ID
 */
export const useGetProjectsSearch = <TData = Awaited<ReturnType<typeof getProjectsSearch>>, TError = ErrorType<void>>(
 params?: GetProjectsSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectsSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectsSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a project by ID
 */
export const getProjectsProjectId = (
    projectId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Project>(
      {url: `/projects/${projectId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProjectsProjectIdQueryKey = (projectId: string,) => {
    return [`/projects/${projectId}`] as const;
    }

    
export const getGetProjectsProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getProjectsProjectId>>, TError = ErrorType<void>>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectsProjectId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectsProjectIdQueryKey(projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectsProjectId>>> = ({ signal }) => getProjectsProjectId(projectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectsProjectId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectsProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectsProjectId>>>
export type GetProjectsProjectIdQueryError = ErrorType<void>

/**
 * @summary Get a project by ID
 */
export const useGetProjectsProjectId = <TData = Awaited<ReturnType<typeof getProjectsProjectId>>, TError = ErrorType<void>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectsProjectId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectsProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a project by ID
 */
export const putProjectsProjectId = (
    projectId: string,
    project: BodyType<Project>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Project>(
      {url: `/projects/${projectId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: project
    },
      options);
    }
  


export const getPutProjectsProjectIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProjectsProjectId>>, TError,{projectId: string;data: BodyType<Project>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putProjectsProjectId>>, TError,{projectId: string;data: BodyType<Project>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProjectsProjectId>>, {projectId: string;data: BodyType<Project>}> = (props) => {
          const {projectId,data} = props ?? {};

          return  putProjectsProjectId(projectId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutProjectsProjectIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProjectsProjectId>>>
    export type PutProjectsProjectIdMutationBody = BodyType<Project>
    export type PutProjectsProjectIdMutationError = ErrorType<void>

    /**
 * @summary Update a project by ID
 */
export const usePutProjectsProjectId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProjectsProjectId>>, TError,{projectId: string;data: BodyType<Project>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutProjectsProjectIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a project by ID
 */
export const deleteProjectsProjectId = (
    projectId: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/projects/${projectId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteProjectsProjectIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectsProjectId>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectsProjectId>>, TError,{projectId: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectsProjectId>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  deleteProjectsProjectId(projectId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectsProjectIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectsProjectId>>>
    
    export type DeleteProjectsProjectIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a project by ID
 */
export const useDeleteProjectsProjectId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectsProjectId>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeleteProjectsProjectIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create a new company
 */
export const postCompanies = (
    company: BodyType<Company>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Company>(
      {url: `/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: company
    },
      options);
    }
  


export const getPostCompaniesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError,{data: BodyType<Company>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError,{data: BodyType<Company>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanies>>, {data: BodyType<Company>}> = (props) => {
          const {data} = props ?? {};

          return  postCompanies(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanies>>>
    export type PostCompaniesMutationBody = BodyType<Company>
    export type PostCompaniesMutationError = ErrorType<void>

    /**
 * @summary Create a new company
 */
export const usePostCompanies = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanies>>, TError,{data: BodyType<Company>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostCompaniesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a project by ID
 */
export const getCompanyCompanyID = (
    companyID: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Company>(
      {url: `/Company/${companyID}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCompanyCompanyIDQueryKey = (companyID: string,) => {
    return [`/Company/${companyID}`] as const;
    }

    
export const getGetCompanyCompanyIDQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyCompanyID>>, TError = ErrorType<void>>(companyID: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyCompanyID>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyCompanyIDQueryKey(companyID);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyCompanyID>>> = ({ signal }) => getCompanyCompanyID(companyID, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyCompanyID>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyCompanyIDQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyCompanyID>>>
export type GetCompanyCompanyIDQueryError = ErrorType<void>

/**
 * @summary Get a project by ID
 */
export const useGetCompanyCompanyID = <TData = Awaited<ReturnType<typeof getCompanyCompanyID>>, TError = ErrorType<void>>(
 companyID: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyCompanyID>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyCompanyIDQueryOptions(companyID,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a project by ID
 */
export const putCompanyCompanyID = (
    companyID: string,
    company: BodyType<Company>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Company>(
      {url: `/Company/${companyID}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: company
    },
      options);
    }
  


export const getPutCompanyCompanyIDMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyCompanyID>>, TError,{companyID: string;data: BodyType<Company>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanyCompanyID>>, TError,{companyID: string;data: BodyType<Company>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanyCompanyID>>, {companyID: string;data: BodyType<Company>}> = (props) => {
          const {companyID,data} = props ?? {};

          return  putCompanyCompanyID(companyID,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutCompanyCompanyIDMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanyCompanyID>>>
    export type PutCompanyCompanyIDMutationBody = BodyType<Company>
    export type PutCompanyCompanyIDMutationError = ErrorType<void>

    /**
 * @summary Update a project by ID
 */
export const usePutCompanyCompanyID = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyCompanyID>>, TError,{companyID: string;data: BodyType<Company>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutCompanyCompanyIDMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a company by ID
 */
export const deleteCompanyCompanyID = (
    companyID: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/Company/${companyID}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCompanyCompanyIDMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyCompanyID>>, TError,{companyID: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyCompanyID>>, TError,{companyID: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyCompanyID>>, {companyID: string}> = (props) => {
          const {companyID} = props ?? {};

          return  deleteCompanyCompanyID(companyID,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyCompanyIDMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyCompanyID>>>
    
    export type DeleteCompanyCompanyIDMutationError = ErrorType<unknown>

    /**
 * @summary Delete a company by ID
 */
export const useDeleteCompanyCompanyID = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyCompanyID>>, TError,{companyID: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeleteCompanyCompanyIDMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create a new license
 */
export const postLicenses = (
    license: BodyType<License>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<License>(
      {url: `/licenses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: license
    },
      options);
    }
  


export const getPostLicensesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLicenses>>, TError,{data: BodyType<License>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postLicenses>>, TError,{data: BodyType<License>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLicenses>>, {data: BodyType<License>}> = (props) => {
          const {data} = props ?? {};

          return  postLicenses(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostLicensesMutationResult = NonNullable<Awaited<ReturnType<typeof postLicenses>>>
    export type PostLicensesMutationBody = BodyType<License>
    export type PostLicensesMutationError = ErrorType<void>

    /**
 * @summary Create a new license
 */
export const usePostLicenses = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLicenses>>, TError,{data: BodyType<License>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostLicensesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a licenses by ID
 */
export const getLicensesId = (
    id: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<License>(
      {url: `/licenses/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLicensesIdQueryKey = (id: string,) => {
    return [`/licenses/${id}`] as const;
    }

    
export const getGetLicensesIdQueryOptions = <TData = Awaited<ReturnType<typeof getLicensesId>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicensesId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLicensesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicensesId>>> = ({ signal }) => getLicensesId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicensesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLicensesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLicensesId>>>
export type GetLicensesIdQueryError = ErrorType<void>

/**
 * @summary Get a licenses by ID
 */
export const useGetLicensesId = <TData = Awaited<ReturnType<typeof getLicensesId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicensesId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLicensesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a project by ID
 */
export const putLicensesId = (
    id: string,
    license: BodyType<License>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<License>(
      {url: `/licenses/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: license
    },
      options);
    }
  


export const getPutLicensesIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLicensesId>>, TError,{id: string;data: BodyType<License>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putLicensesId>>, TError,{id: string;data: BodyType<License>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLicensesId>>, {id: string;data: BodyType<License>}> = (props) => {
          const {id,data} = props ?? {};

          return  putLicensesId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutLicensesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putLicensesId>>>
    export type PutLicensesIdMutationBody = BodyType<License>
    export type PutLicensesIdMutationError = ErrorType<void>

    /**
 * @summary Update a project by ID
 */
export const usePutLicensesId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLicensesId>>, TError,{id: string;data: BodyType<License>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutLicensesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a License by ID
 */
export const deleteLicensesId = (
    id: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/licenses/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteLicensesIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLicensesId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLicensesId>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLicensesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLicensesId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteLicensesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLicensesId>>>
    
    export type DeleteLicensesIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a License by ID
 */
export const useDeleteLicensesId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLicensesId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeleteLicensesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create a new Hiring Campaign
 */
export const postHiringcampaigns = (
    hiringCampaign: BodyType<HiringCampaign>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<HiringCampaign>(
      {url: `/hiringcampaigns`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hiringCampaign
    },
      options);
    }
  


export const getPostHiringcampaignsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHiringcampaigns>>, TError,{data: BodyType<HiringCampaign>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postHiringcampaigns>>, TError,{data: BodyType<HiringCampaign>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHiringcampaigns>>, {data: BodyType<HiringCampaign>}> = (props) => {
          const {data} = props ?? {};

          return  postHiringcampaigns(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostHiringcampaignsMutationResult = NonNullable<Awaited<ReturnType<typeof postHiringcampaigns>>>
    export type PostHiringcampaignsMutationBody = BodyType<HiringCampaign>
    export type PostHiringcampaignsMutationError = ErrorType<void>

    /**
 * @summary Create a new Hiring Campaign
 */
export const usePostHiringcampaigns = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHiringcampaigns>>, TError,{data: BodyType<HiringCampaign>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostHiringcampaignsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a list of all Hiring Campaign by using the sub
 */
export const getHiringcampaignsSearch = (
    params?: GetHiringcampaignsSearchParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetHiringcampaignsSearch200>(
      {url: `/hiringcampaigns/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetHiringcampaignsSearchQueryKey = (params?: GetHiringcampaignsSearchParams,) => {
    return [`/hiringcampaigns/search`, ...(params ? [params]: [])] as const;
    }

    
export const getGetHiringcampaignsSearchQueryOptions = <TData = Awaited<ReturnType<typeof getHiringcampaignsSearch>>, TError = ErrorType<void>>(params?: GetHiringcampaignsSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringcampaignsSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHiringcampaignsSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHiringcampaignsSearch>>> = ({ signal }) => getHiringcampaignsSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHiringcampaignsSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHiringcampaignsSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getHiringcampaignsSearch>>>
export type GetHiringcampaignsSearchQueryError = ErrorType<void>

/**
 * @summary Get a list of all Hiring Campaign by using the sub
 */
export const useGetHiringcampaignsSearch = <TData = Awaited<ReturnType<typeof getHiringcampaignsSearch>>, TError = ErrorType<void>>(
 params?: GetHiringcampaignsSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringcampaignsSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHiringcampaignsSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a Hiring Campaign by ID
 */
export const getHiringcampaignsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<HiringCampaign>(
      {url: `/hiringcampaigns/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetHiringcampaignsIdQueryKey = (id: string,) => {
    return [`/hiringcampaigns/${id}`] as const;
    }

    
export const getGetHiringcampaignsIdQueryOptions = <TData = Awaited<ReturnType<typeof getHiringcampaignsId>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringcampaignsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHiringcampaignsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHiringcampaignsId>>> = ({ signal }) => getHiringcampaignsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHiringcampaignsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHiringcampaignsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getHiringcampaignsId>>>
export type GetHiringcampaignsIdQueryError = ErrorType<void>

/**
 * @summary Get a Hiring Campaign by ID
 */
export const useGetHiringcampaignsId = <TData = Awaited<ReturnType<typeof getHiringcampaignsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringcampaignsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHiringcampaignsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a Hiring Campaign by ID
 */
export const putHiringcampaignsId = (
    id: string,
    hiringCampaign: BodyType<HiringCampaign>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<HiringCampaign>(
      {url: `/hiringcampaigns/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hiringCampaign
    },
      options);
    }
  


export const getPutHiringcampaignsIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHiringcampaignsId>>, TError,{id: string;data: BodyType<HiringCampaign>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putHiringcampaignsId>>, TError,{id: string;data: BodyType<HiringCampaign>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putHiringcampaignsId>>, {id: string;data: BodyType<HiringCampaign>}> = (props) => {
          const {id,data} = props ?? {};

          return  putHiringcampaignsId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutHiringcampaignsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putHiringcampaignsId>>>
    export type PutHiringcampaignsIdMutationBody = BodyType<HiringCampaign>
    export type PutHiringcampaignsIdMutationError = ErrorType<void>

    /**
 * @summary Update a Hiring Campaign by ID
 */
export const usePutHiringcampaignsId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHiringcampaignsId>>, TError,{id: string;data: BodyType<HiringCampaign>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutHiringcampaignsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a Hiring Campaign by ID
 */
export const deleteHiringcampaignsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/hiringcampaigns/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteHiringcampaignsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHiringcampaignsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHiringcampaignsId>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHiringcampaignsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHiringcampaignsId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteHiringcampaignsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHiringcampaignsId>>>
    
    export type DeleteHiringcampaignsIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete a Hiring Campaign by ID
 */
export const useDeleteHiringcampaignsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHiringcampaignsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeleteHiringcampaignsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create a new hiring result
 */
export const postHiringresults = (
    hiringResult: BodyType<HiringResult>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<HiringResult>(
      {url: `/hiringresults`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hiringResult
    },
      options);
    }
  


export const getPostHiringresultsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHiringresults>>, TError,{data: BodyType<HiringResult>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postHiringresults>>, TError,{data: BodyType<HiringResult>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHiringresults>>, {data: BodyType<HiringResult>}> = (props) => {
          const {data} = props ?? {};

          return  postHiringresults(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostHiringresultsMutationResult = NonNullable<Awaited<ReturnType<typeof postHiringresults>>>
    export type PostHiringresultsMutationBody = BodyType<HiringResult>
    export type PostHiringresultsMutationError = ErrorType<void>

    /**
 * @summary Create a new hiring result
 */
export const usePostHiringresults = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHiringresults>>, TError,{data: BodyType<HiringResult>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostHiringresultsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update hiring results by hiring campaign ID and sub
 */
export const putHiringresults = (
    hiringResult: BodyType<HiringResult>,
    params?: PutHiringresultsParams,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<HiringResult>(
      {url: `/hiringresults`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hiringResult,
        params
    },
      options);
    }
  


export const getPutHiringresultsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHiringresults>>, TError,{data: BodyType<HiringResult>;params?: PutHiringresultsParams}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putHiringresults>>, TError,{data: BodyType<HiringResult>;params?: PutHiringresultsParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putHiringresults>>, {data: BodyType<HiringResult>;params?: PutHiringresultsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putHiringresults(data,params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutHiringresultsMutationResult = NonNullable<Awaited<ReturnType<typeof putHiringresults>>>
    export type PutHiringresultsMutationBody = BodyType<HiringResult>
    export type PutHiringresultsMutationError = ErrorType<void>

    /**
 * @summary Update hiring results by hiring campaign ID and sub
 */
export const usePutHiringresults = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHiringresults>>, TError,{data: BodyType<HiringResult>;params?: PutHiringresultsParams}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutHiringresultsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get a list of all Hiring hiringresults with different query
 */
export const getHiringresultsSearch = (
    params?: GetHiringresultsSearchParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetHiringresultsSearch200>(
      {url: `/hiringresults/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetHiringresultsSearchQueryKey = (params?: GetHiringresultsSearchParams,) => {
    return [`/hiringresults/search`, ...(params ? [params]: [])] as const;
    }

    
export const getGetHiringresultsSearchQueryOptions = <TData = Awaited<ReturnType<typeof getHiringresultsSearch>>, TError = ErrorType<void>>(params?: GetHiringresultsSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringresultsSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHiringresultsSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHiringresultsSearch>>> = ({ signal }) => getHiringresultsSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHiringresultsSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHiringresultsSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getHiringresultsSearch>>>
export type GetHiringresultsSearchQueryError = ErrorType<void>

/**
 * @summary Get a list of all Hiring hiringresults with different query
 */
export const useGetHiringresultsSearch = <TData = Awaited<ReturnType<typeof getHiringresultsSearch>>, TError = ErrorType<void>>(
 params?: GetHiringresultsSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringresultsSearch>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHiringresultsSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get hiring results by hiring campaign ID
 */
export const getHiringCampaignsResultsHiringCampaignId = (
    hiringCampaignId: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<HiringResult[]>(
      {url: `/hiringCampaigns/results/${hiringCampaignId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetHiringCampaignsResultsHiringCampaignIdQueryKey = (hiringCampaignId: string,) => {
    return [`/hiringCampaigns/results/${hiringCampaignId}`] as const;
    }

    
export const getGetHiringCampaignsResultsHiringCampaignIdQueryOptions = <TData = Awaited<ReturnType<typeof getHiringCampaignsResultsHiringCampaignId>>, TError = ErrorType<void>>(hiringCampaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringCampaignsResultsHiringCampaignId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHiringCampaignsResultsHiringCampaignIdQueryKey(hiringCampaignId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHiringCampaignsResultsHiringCampaignId>>> = ({ signal }) => getHiringCampaignsResultsHiringCampaignId(hiringCampaignId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(hiringCampaignId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHiringCampaignsResultsHiringCampaignId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHiringCampaignsResultsHiringCampaignIdQueryResult = NonNullable<Awaited<ReturnType<typeof getHiringCampaignsResultsHiringCampaignId>>>
export type GetHiringCampaignsResultsHiringCampaignIdQueryError = ErrorType<void>

/**
 * @summary Get hiring results by hiring campaign ID
 */
export const useGetHiringCampaignsResultsHiringCampaignId = <TData = Awaited<ReturnType<typeof getHiringCampaignsResultsHiringCampaignId>>, TError = ErrorType<void>>(
 hiringCampaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringCampaignsResultsHiringCampaignId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHiringCampaignsResultsHiringCampaignIdQueryOptions(hiringCampaignId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get hiring result by ID
 */
export const getHiringresultsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<HiringResult>(
      {url: `/hiringresults/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetHiringresultsIdQueryKey = (id: string,) => {
    return [`/hiringresults/${id}`] as const;
    }

    
export const getGetHiringresultsIdQueryOptions = <TData = Awaited<ReturnType<typeof getHiringresultsId>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringresultsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHiringresultsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHiringresultsId>>> = ({ signal }) => getHiringresultsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHiringresultsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHiringresultsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getHiringresultsId>>>
export type GetHiringresultsIdQueryError = ErrorType<void>

/**
 * @summary Get hiring result by ID
 */
export const useGetHiringresultsId = <TData = Awaited<ReturnType<typeof getHiringresultsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHiringresultsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHiringresultsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update hiring result by ID
 */
export const putHiringresultsId = (
    id: string,
    performance: BodyType<Performance>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/hiringresults/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: performance
    },
      options);
    }
  


export const getPutHiringresultsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHiringresultsId>>, TError,{id: string;data: BodyType<Performance>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putHiringresultsId>>, TError,{id: string;data: BodyType<Performance>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putHiringresultsId>>, {id: string;data: BodyType<Performance>}> = (props) => {
          const {id,data} = props ?? {};

          return  putHiringresultsId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutHiringresultsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putHiringresultsId>>>
    export type PutHiringresultsIdMutationBody = BodyType<Performance>
    export type PutHiringresultsIdMutationError = ErrorType<unknown>

    /**
 * @summary Update hiring result by ID
 */
export const usePutHiringresultsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHiringresultsId>>, TError,{id: string;data: BodyType<Performance>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutHiringresultsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete hiring result by ID
 */
export const deleteHiringresultsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/hiringresults/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteHiringresultsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHiringresultsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHiringresultsId>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHiringresultsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteHiringresultsId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteHiringresultsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHiringresultsId>>>
    
    export type DeleteHiringresultsIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete hiring result by ID
 */
export const useDeleteHiringresultsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHiringresultsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeleteHiringresultsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Project Context with templateID and skill
 */
export const getProjectContext = (
    params: GetProjectContextParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<ProjectContext>(
      {url: `/projectContext`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetProjectContextQueryKey = (params: GetProjectContextParams,) => {
    return [`/projectContext`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProjectContextQueryOptions = <TData = Awaited<ReturnType<typeof getProjectContext>>, TError = ErrorType<void>>(params: GetProjectContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectContext>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectContextQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectContext>>> = ({ signal }) => getProjectContext(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectContext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProjectContextQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectContext>>>
export type GetProjectContextQueryError = ErrorType<void>

/**
 * @summary Get Project Context with templateID and skill
 */
export const useGetProjectContext = <TData = Awaited<ReturnType<typeof getProjectContext>>, TError = ErrorType<void>>(
 params: GetProjectContextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectContext>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProjectContextQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Add performances of a Project Object with project ID
 */
export const putEvaluationEnvironment = (
    performance: BodyType<Performance>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<Performance>(
      {url: `/evaluationEnvironment`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: performance
    },
      options);
    }
  


export const getPutEvaluationEnvironmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEvaluationEnvironment>>, TError,{data: BodyType<Performance>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putEvaluationEnvironment>>, TError,{data: BodyType<Performance>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEvaluationEnvironment>>, {data: BodyType<Performance>}> = (props) => {
          const {data} = props ?? {};

          return  putEvaluationEnvironment(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutEvaluationEnvironmentMutationResult = NonNullable<Awaited<ReturnType<typeof putEvaluationEnvironment>>>
    export type PutEvaluationEnvironmentMutationBody = BodyType<Performance>
    export type PutEvaluationEnvironmentMutationError = ErrorType<void>

    /**
 * @summary Add performances of a Project Object with project ID
 */
export const usePutEvaluationEnvironment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEvaluationEnvironment>>, TError,{data: BodyType<Performance>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutEvaluationEnvironmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a new permission record.
 * @summary Create a new permission
 */
export const postPermissions = (
    permission: BodyType<Permission>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<string>(
      {url: `/permissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: permission
    },
      options);
    }
  


export const getPostPermissionsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPermissions>>, TError,{data: BodyType<Permission>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postPermissions>>, TError,{data: BodyType<Permission>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPermissions>>, {data: BodyType<Permission>}> = (props) => {
          const {data} = props ?? {};

          return  postPermissions(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postPermissions>>>
    export type PostPermissionsMutationBody = BodyType<Permission>
    export type PostPermissionsMutationError = ErrorType<void>

    /**
 * @summary Create a new permission
 */
export const usePostPermissions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPermissions>>, TError,{data: BodyType<Permission>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostPermissionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieve a specific permission record by ID.
 * @summary Get a specific permission
 */
export const getPermissionsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<Permission>(
      {url: `/permissions/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPermissionsIdQueryKey = (id: string,) => {
    return [`/permissions/${id}`] as const;
    }

    
export const getGetPermissionsIdQueryOptions = <TData = Awaited<ReturnType<typeof getPermissionsId>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionsId>>> = ({ signal }) => getPermissionsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissionsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPermissionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionsId>>>
export type GetPermissionsIdQueryError = ErrorType<void>

/**
 * @summary Get a specific permission
 */
export const useGetPermissionsId = <TData = Awaited<ReturnType<typeof getPermissionsId>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionsId>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPermissionsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update a permission record by ID.
 * @summary Update a specific permission
 */
export const putPermissionsId = (
    id: string,
    permission: BodyType<Permission>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<void>(
      {url: `/permissions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: permission
    },
      options);
    }
  


export const getPutPermissionsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPermissionsId>>, TError,{id: string;data: BodyType<Permission>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putPermissionsId>>, TError,{id: string;data: BodyType<Permission>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPermissionsId>>, {id: string;data: BodyType<Permission>}> = (props) => {
          const {id,data} = props ?? {};

          return  putPermissionsId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutPermissionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPermissionsId>>>
    export type PutPermissionsIdMutationBody = BodyType<Permission>
    export type PutPermissionsIdMutationError = ErrorType<unknown>

    /**
 * @summary Update a specific permission
 */
export const usePutPermissionsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPermissionsId>>, TError,{id: string;data: BodyType<Permission>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPutPermissionsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete a permission record by ID.
 * @summary Delete a specific permission
 */
export const deletePermissionsId = (
    id: string,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<string>(
      {url: `/permissions/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePermissionsIdMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermissionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePermissionsId>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePermissionsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePermissionsId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeletePermissionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePermissionsId>>>
    
    export type DeletePermissionsIdMutationError = ErrorType<void>

    /**
 * @summary Delete a specific permission
 */
export const useDeletePermissionsId = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermissionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getDeletePermissionsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get presigned url to download SEB file to download SEB browser
 * @summary Get presigned url to download SEB file
 */
export const getSebFile = (
    params?: GetSebFileParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<void>(
      {url: `/seb/file`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSebFileQueryKey = (params?: GetSebFileParams,) => {
    return [`/seb/file`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSebFileQueryOptions = <TData = Awaited<ReturnType<typeof getSebFile>>, TError = ErrorType<unknown>>(params?: GetSebFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSebFile>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSebFileQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSebFile>>> = ({ signal }) => getSebFile(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSebFile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSebFileQueryResult = NonNullable<Awaited<ReturnType<typeof getSebFile>>>
export type GetSebFileQueryError = ErrorType<unknown>

/**
 * @summary Get presigned url to download SEB file
 */
export const useGetSebFile = <TData = Awaited<ReturnType<typeof getSebFile>>, TError = ErrorType<unknown>>(
 params?: GetSebFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSebFile>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSebFileQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * if status is 200, then the browser is indeed SEB
 * @summary Confirm that user agent is indeed SEB
 */
export const getSebIsSEB = (
    
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<string>(
      {url: `/seb/isSEB`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSebIsSEBQueryKey = () => {
    return [`/seb/isSEB`] as const;
    }

    
export const getGetSebIsSEBQueryOptions = <TData = Awaited<ReturnType<typeof getSebIsSEB>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSebIsSEB>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSebIsSEBQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSebIsSEB>>> = ({ signal }) => getSebIsSEB(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSebIsSEB>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSebIsSEBQueryResult = NonNullable<Awaited<ReturnType<typeof getSebIsSEB>>>
export type GetSebIsSEBQueryError = ErrorType<void>

/**
 * @summary Confirm that user agent is indeed SEB
 */
export const useGetSebIsSEB = <TData = Awaited<ReturnType<typeof getSebIsSEB>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSebIsSEB>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSebIsSEBQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Endpoint to submit a job application with JSON data and a resume file.
 * @summary Submit job application
 */
export const postApply = (
    postApplyBody: BodyType<PostApplyBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      const formData = new FormData();
if(postApplyBody.formData !== undefined) {
 formData.append('formData', postApplyBody.formData)
 }
if(postApplyBody.resume !== undefined) {
 formData.append('resume', postApplyBody.resume)
 }

      return customClient<PostApply200>(
      {url: `/apply`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostApplyMutationOptions = <TError = ErrorType<PostApply400 | PostApply500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApply>>, TError,{data: BodyType<PostApplyBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postApply>>, TError,{data: BodyType<PostApplyBody>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApply>>, {data: BodyType<PostApplyBody>}> = (props) => {
          const {data} = props ?? {};

          return  postApply(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostApplyMutationResult = NonNullable<Awaited<ReturnType<typeof postApply>>>
    export type PostApplyMutationBody = BodyType<PostApplyBody>
    export type PostApplyMutationError = ErrorType<PostApply400 | PostApply500>

    /**
 * @summary Submit job application
 */
export const usePostApply = <TError = ErrorType<PostApply400 | PostApply500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApply>>, TError,{data: BodyType<PostApplyBody>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostApplyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Endpoint to run tests.
 * @summary Run tests
 */
export const postRuntest = (
    postRuntestBody: BodyType<PostRuntestBody>,
 options?: SecondParameter<typeof customClient>,) => {
      
      
      return customClient<PostRuntest200>(
      {url: `/runtest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRuntestBody
    },
      options);
    }
  


export const getPostRuntestMutationOptions = <TError = ErrorType<PostRuntest400 | PostRuntest500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRuntest>>, TError,{data: BodyType<PostRuntestBody>}, TContext>, request?: SecondParameter<typeof customClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postRuntest>>, TError,{data: BodyType<PostRuntestBody>}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRuntest>>, {data: BodyType<PostRuntestBody>}> = (props) => {
          const {data} = props ?? {};

          return  postRuntest(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRuntestMutationResult = NonNullable<Awaited<ReturnType<typeof postRuntest>>>
    export type PostRuntestMutationBody = BodyType<PostRuntestBody>
    export type PostRuntestMutationError = ErrorType<PostRuntest400 | PostRuntest500>

    /**
 * @summary Run tests
 */
export const usePostRuntest = <TError = ErrorType<PostRuntest400 | PostRuntest500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRuntest>>, TError,{data: BodyType<PostRuntestBody>}, TContext>, request?: SecondParameter<typeof customClient>}
) => {

      const mutationOptions = getPostRuntestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieves the type of evaluation progress based on the skill and project ID.
 * @summary Get evaluation progress
 */
export const getEvaluationprogress = (
    params: GetEvaluationprogressParams,
 options?: SecondParameter<typeof customClient>,signal?: AbortSignal
) => {
      
      
      return customClient<GetEvaluationprogress200>(
      {url: `/evaluationprogress`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetEvaluationprogressQueryKey = (params: GetEvaluationprogressParams,) => {
    return [`/evaluationprogress`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEvaluationprogressQueryOptions = <TData = Awaited<ReturnType<typeof getEvaluationprogress>>, TError = ErrorType<void>>(params: GetEvaluationprogressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluationprogress>>, TError, TData>>, request?: SecondParameter<typeof customClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvaluationprogressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaluationprogress>>> = ({ signal }) => getEvaluationprogress(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvaluationprogress>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEvaluationprogressQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaluationprogress>>>
export type GetEvaluationprogressQueryError = ErrorType<void>

/**
 * @summary Get evaluation progress
 */
export const useGetEvaluationprogress = <TData = Awaited<ReturnType<typeof getEvaluationprogress>>, TError = ErrorType<void>>(
 params: GetEvaluationprogressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluationprogress>>, TError, TData>>, request?: SecondParameter<typeof customClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetEvaluationprogressQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



